var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.41 6.994a2.53 2.53 0 00-2.53 2.53V32.71c0 .474.263.948.685 1.159.422.21.896.158 1.265-.105l8.168-5.797 8.116 5.797a1.31 1.31 0 001.317.105c.422-.21.685-.685.685-1.16V9.524c0-1.37-1.16-2.53-2.53-2.53H12.41z"
  })));
}
export default SvgBookmarked;